/* script */
//
//
//
//

// Components
import BaseControl from './BaseControl.vue';

const __vue_script__ = {
    name: 'AngularCustomControl',

    extends: BaseControl,

    props: {
        legacy: {
            type: Object,
            required: true
        },

        options: {
            type: Object,
            required: true
        },

        model: {
            type: Object,
            default: () => ({})
        },

        value: {
            type: [Array, String, Object, Number, Boolean],
            default: () => null
        },

        edit: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            // OUTBOUND.
            // We need to use a proxy to make sure that the model is reactive
            // from Angular towards Vue.
            innerModel: new Proxy(this.model, {
                get: (target, key, receiver) => Reflect.get(target, key, receiver),
                set: (target, key, value) => {
                    if (target[key] !== value) {
                        this.$emit('input', key, value);
                    }
                    return Reflect.set(target, key, value);
                },
                apply: (target, thisArg, argumentsList) => {
                    this.$emit('input', this.legacy.field, thisArg);
                    return Reflect.apply(target, thisArg, argumentsList);
                },
            })
        };
    },

    computed: {
        /** @return {boolean} */
        enabled() {
            return true;
        }
    },

    watch: {
        model: {
            immediate: true,
            deep: true,
            handler() {
                if (!this.scope) {
                    return;
                }

                // INBOUND.
                // If the model changes, we need to notify Angular about it.
                // this.scope[this.options.modelMapping] = this.innerModel;
                this.scope.$applyAsync();
            }
        }
    },

    mounted() {
        if (!this.enabled || !this.$refs.component) {
            console.debug('[AngularCustomControl] Skipping mount because not ready "%s":', this.legacy.field, this.legacy);
            return;
        }

        const pageInjector = angular.element(document).injector();
        const $controller = pageInjector.get('$controller');

        pageInjector.invoke(['$compile', '$rootScope', ($compile, $rootScope) => {
            $rootScope.$applyAsync(() => {
                const scope = angular.element(this.$refs.component).scope()?.$new(true);

                if (!scope) {
                    console.debug('[AngularCustomControl] Could not mount "%s":', this.legacy.field);
                    // The component might have been unmounted faster than the
                    // apply async routine could run.
                    return;
                }

                scope.template = this.$const.TEMPLATE_URL_MAPPING[this.options.templateUrl] || this.options.templateUrl;
                scope.controller = ['$scope', (controllerScope) => {
                    this.scope = controllerScope;
                    controllerScope.model = this.innerModel;
                    return $controller(this.options.controller, {
                        fieldDescriptor: this.legacy,
                        $scope: controllerScope,
                        model: this.innerModel,
                        saveFn: this.save
                    });
                }];

                console.debug('[AngularCustomControl] Mounting "%s":', this.legacy.field);
                $compile(this.$refs.component)(scope);
                this.rootScope = scope;
            });
        }]);
    },

    beforeDestroy() {
        if (this.rootScope) {
            console.debug('[AngularCustomControl] Destroying "%s":', this.legacy.field);
            this.rootScope.$destroy();
        }
    },

    methods: {
        save(...args) {
            console.error('[AngularCustomControl] Save callback called with:', ...args);
            throw new Error('Save callback not implemented');
        }
    },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('control-decorator',{staticClass:"custom-control",attrs:{"label":_vm.label,"tip":_vm.tip,"hint":_vm.hint,"errors":_vm.errors,"uid":_vm.uid,"hint-after-label":true,"dependant":_vm.dependant}},[_c('div',{ref:"component",staticClass:"angular-custom-control"},[_c('div',{attrs:{"ng-controller":"controller","ng-include":"template"}})])]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AngularCustomControl.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__